__webpack_require__.p = "https://static.fastly.carvana.io/valuetrackerui/_next/";